package org.braunequip.web.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import gr.tech.lkpksignature.components.SignaturePad.loadSigPad
import kotlinx.browser.document
import kotlinx.coroutines.launch
import org.braunequip.web.components.forms.*
import org.braunequip.web.components.layouts.PageLayout
import org.braunequip.web.components.models.ContactsDTO
import org.braunequip.web.styles.toSitePalette
import org.braunequip.web.util.*
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLTextAreaElement

data class EmployeePortalUiState(
    val toggledForm: String = ""
)

@Page
@Composable
fun EmployeePortalPage() {
    PortalPinForm {
        EmployeePortalScreen()
    }
}

@Composable
fun EmployeePortalScreen() {
    val scope = rememberCoroutineScope()
    var uiState by remember { mutableStateOf(EmployeePortalUiState()) }
    val breakpoint = rememberBreakpoint()


    PageLayout("Contact Us") {
        Section(Modifier.classNames("hero").backgroundColor(Colors.WhiteSmoke).toAttrs()) {
            Div(Modifier.classNames("container", "is-widescreen").toAttrs()) {
                Div(Modifier.classNames("hero-body", "has-text-centered").toAttrs()) {
                    H1(Modifier.fontFamily(Constants.FONT_FAMILY2).classNames("title", "is-1", "has-text-black").toAttrs()) { Text("Employee Portal") }
                }
            }
        }

        Section(Modifier.fontFamily(Constants.FONT_FAMILY2).classNames("section").toAttrs()) {
            Div(
                attrs = Modifier
                    .classNames("container", "is-widescreen")
                    .toAttrs()
            ) {
                SimpleGrid(
                    numColumns = numColumns(1, 2),
                    modifier = Modifier
                ) {
                    Column(
                        modifier = Modifier
                            .padding(all = 1.cssRem)
                            .margin(
                                right = if (breakpoint >= Breakpoint.MD) 1.cssRem else 0.px
                            )
                            .borderRight(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = if (breakpoint >= Breakpoint.MD) Colors.Black else Colors.Transparent
                            ),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        //Time Off Request Form
                        Div(Modifier.classNames("block").fillMaxWidth().toAttrs()) {
                            H3(Modifier.classNames("title", "is-3", "has-text-dark").toAttrs()) {
                                Text("Time Off Request Form")
                            }

                            P(Modifier.classNames("is-6").toAttrs()) {
                                Text("Please submit any vacation or time off requests via the form.")
                            }

                            SubmitButton(
                                text = "TOGGLE FORM",
                                onClick = {
                                    uiState = uiState.copy(toggledForm = InputIDs.TimeOffForm.formName)
                                }
                            )
                        }

                        //Diesel Fuel Log
                        Div(Modifier.classNames("block").fillMaxWidth().toAttrs()) {
                            H3(Modifier.classNames("title", "is-3", "has-text-dark").toAttrs()) {
                                Text("Diesel Fuel Log")
                            }

                            P(Modifier.classNames("is-6").toAttrs()) {
                                Text("Any fueling done at yard must have a form submitted.")
                            }

                            SubmitButton(
                                text = "TOGGLE FORM",
                                onClick = {
                                    uiState = uiState.copy(toggledForm = InputIDs.DieselLogForm.formName)
                                }
                            )
                        }

                        //Equipment Repair Form
                        Div(Modifier.classNames("block").fillMaxWidth().toAttrs()) {
                            H3(Modifier.classNames("title", "is-3", "has-text-dark").toAttrs()) {
                                Text("Equipment Repair Form")
                            }

                            P(Modifier.classNames("is-6").toAttrs()) {
                                Text("Submit any known repairs or issues with equipment for Mechanic review.")
                            }

                            SubmitButton(
                                text = "TOGGLE FORM",
                                onClick = {
                                    uiState = uiState.copy(toggledForm = InputIDs.EquipRepairForm.formName)
                                }
                            )
                        }

                        HorizontalDivider(modifier = Modifier
                            .displayUntil(Breakpoint.MD)
                            .fillMaxWidth()
                            .margin(topBottom = 2.cssRem)
                        )
                    }


                    Column(
                        modifier = Modifier,
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        when (uiState.toggledForm) {
                            InputIDs.TimeOffForm.formName -> {
                                TimeOffForm(scope) {
                                    uiState = uiState.copy(toggledForm = "")
                                }
                            }

                            InputIDs.DieselLogForm.formName -> {
                                DieselLogForm(scope) {
                                    uiState = uiState.copy(toggledForm = "")
                                }
                            }

                            InputIDs.EquipRepairForm.formName -> {
                                EquipmentRepairRequestForm(scope) {
                                    uiState = uiState.copy(toggledForm = "")
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}